import PropTypes from 'prop-types';
import { secondsToTimeWithHour } from 'src/common/utils/secondsToTime';
import {
  MORE,
  LESS,
  DURATION,
} from 'src/common/constants/localizations/containerItems';
import cssVariables from 'src/common/styles/variables';
import CollapsibleItem from '../../../shared/CollapsibleItem';
import Text from '../../../Text';
import css from '../../shared/guide-item.module.scss';
import PlayableSection from './status/PlayableSection';

const styles = {
  container: {
    padding: '15px 0px',
  },
  moreLabel: {
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: '16px',
    fontFamily: cssVariables['--primary-font-med'],
  },
  mainContent: {
    marginLeft: 50,
  },
};

const Status = ({ guideItem, index }) => {
  const { duration } = guideItem.actions.play;
  const canExpand =
    guideItem.actions.expand && guideItem.actions.expand.canExpand;

  return (
    <div
      className="row"
      style={styles.container}
      data-testid={`guideItem-${index}`}
      data-testtype="status"
    >
      <div className="col-xs-12" data-id={`status-${guideItem.guideId}`}>
        <PlayableSection guideItem={guideItem} />
        {canExpand && (!!duration || guideItem.description) && (
          <div style={styles.mainContent} data-testid="statusMainContent">
            <CollapsibleItem
              moreText={<Text name={MORE} />}
              lessText={<Text name={LESS} />}
              className={css.statusFontSection}
              labelStyle={styles.moreLabel}
            >
              <div
                data-testid="description"
                className={css.guideItemDescription}
              >
                {guideItem.description}
                {!!duration && (
                  <div
                    data-testid="duration"
                    className={css.guideItemDescription}
                  >
                    <p className={css.guideItemDurationContainer}>
                      <Text name={DURATION} />
                      {secondsToTimeWithHour(duration)}
                    </p>
                  </div>
                )}
              </div>
            </CollapsibleItem>
          </div>
        )}
      </div>
    </div>
  );
};

Status.propTypes = {
  guideItem: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
};

export default Status;
